import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";
import { isCapacitorPlatform } from "@src/appV2/lib/utils/capacitor/platformUtils";
import { useEffect, useState } from "react";

import { getZendeskJWTMessagingSDK } from "../api/zendesk";

declare global {
  interface Window {
    zE: (x: string, y: string, z?: (callback: (token?: string) => void) => void) => void;
  }
}

export function useZendeskMessaging() {
  const [webWidgetRendered, setWebWidgetRendered] = useState<boolean>(false);

  // Doc ref - https://developer.zendesk.com/documentation/zendesk-web-widget-sdks/sdks/web/sdk_api_reference/#authentication
  useEffect(() => {
    if (isCapacitorPlatform()) {
      return;
    }

    if (!webWidgetRendered) {
      return;
    }
    window.zE("messenger", "loginUser", function (callback) {
      getZendeskJWTMessagingSDK()
        .then(callback)
        .catch((error) => {
          logError(APP_V2_APP_EVENTS.ZENDESK_LOGIN_ERROR, { error });
        });
    });
    window.zE("messenger", "hide");
  }, [webWidgetRendered]);

  useEffect(() => {
    if (isCapacitorPlatform()) {
      return;
    }

    // Doc ref - https://support.zendesk.com/hc/en-us/articles/4500748175258-Installing-the-Web-Widget-in-a-website-or-Help-Center
    const script = document.createElement("script");
    script.id = environmentConfig.REACT_APP_ZENDESK_WEB_WIDGET_ID;
    script.src = environmentConfig.REACT_APP_ZENDESK_MESSAGING_WIDGET_URL;
    document.body.appendChild(script);
    script.addEventListener("load", () => setWebWidgetRendered(true));

    return () => {
      // Only call zE if it's loaded (script might not have finished loading yet)
      if (typeof window.zE === "function") {
        window.zE("messenger", "logoutUser");
      }
      document.body.removeChild(script);
    };
  }, []);
}
